import React from 'react'

const Tick = (props: any) => {
  return (
    <svg {...props} width="100%" height="100%" viewBox="0 0 37 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3_77)">
        <path
          d="M6.625 20.25L14.5 28.125L32.5 10.125"
          stroke="currentColor"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}

export default Tick
